import type { LevelDefinition } from './Level.ts';

/**
 * Level 3 — delivery.
 *
 * The objective is the ball, and the fluid is the only thing that can move it.
 *
 * The only door out of the upper room is on the right, and the goal is at the bottom
 * left — so pulling straight towards the goal only presses everything into the solid half
 * of the funnel. The route has to go the wrong way first: right through the door, down,
 * under the divider, and back left. One magnet to launch, one to collect.
 */
export const level03: LevelDefinition = {
  id: 'level03',
  name: 'Delivery',
  hint: 'The ball has to reach the goal, and only the fluid can push it.',
  magnetsAvailable: 3,
  fluid: {
    amount: 440,
    source: { x: 500, y: 380 },
    radius: 46,
  },
  ball: { x: 660, y: 760, radius: 40 },
  goal: { x: 250, y: 1330, radius: 105, type: 'ball' },
  walls: [
    // Arena.
    { type: 'segment', x1: 110, y1: 210, x2: 890, y2: 210, thickness: 26 },
    { type: 'segment', x1: 890, y1: 210, x2: 890, y2: 1450, thickness: 26 },
    { type: 'segment', x1: 890, y1: 1450, x2: 110, y2: 1450, thickness: 26 },
    { type: 'segment', x1: 110, y1: 1450, x2: 110, y2: 210, thickness: 26 },

    // The floor of the upper room, with its one door on the right. It is 180 wide for an
    // 80-wide ball, because a gap the ball only just clears is a gap it jams in.
    { type: 'segment', x1: 110, y1: 860, x2: 620, y2: 860, thickness: 26 },
    { type: 'segment', x1: 800, y1: 860, x2: 890, y2: 860, thickness: 26 },

    // The divider, stopping short of the floor so the lower room can be crossed
    // underneath it.
    { type: 'segment', x1: 430, y1: 1010, x2: 430, y2: 1230, thickness: 26 },
  ],
};
